(() => {
  const normalize = (value = '') =>
    String(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

  const getCatalog = () => {
    if (!window.__isPromocionalesCatalogPromise) {
      window.__isPromocionalesCatalogPromise = fetch('/products.json?limit=250', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Catalog ${response.status}`);
          return response.json();
        })
        .then((data) => Array.isArray(data.products) ? data.products : [])
        .catch(() => []);
    }
    return window.__isPromocionalesCatalogPromise;
  };

  const scoreProduct = (product, term) => {
    const title = normalize(product.title);
    const productType = normalize(product.product_type);
    const tags = normalize(Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || ''));
    const words = title.split(/\s+/);
    let score = 0;

    if (title === term) score = 500;
    else if (title.startsWith(term)) score = 450;
    else if (words.some((word) => word.startsWith(term))) score = 400;
    else if (title.includes(term)) score = 350;
    else if (productType.includes(term)) score = 220;
    else if (tags.includes(term)) score = 180;

    return score;
  };

  const createProductItem = (product, index) => {
    const li = document.createElement('li');
    li.id = `is-predictive-fallback-${index}`;
    li.className = 'predictive-search__list-item';
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');

    const link = document.createElement('a');
    link.href = `/products/${product.handle}`;
    link.className = 'predictive-search__item predictive-search__item--link-with-thumbnail link link--text';
    link.tabIndex = -1;

    const imageSrc = product.images?.[0]?.src;
    if (imageSrc) {
      const img = document.createElement('img');
      img.className = 'predictive-search__image';
      img.src = imageSrc;
      img.alt = product.title || '';
      img.width = 50;
      img.height = 50;
      img.loading = 'lazy';
      link.appendChild(img);
    }

    const content = document.createElement('div');
    content.className = 'predictive-search__item-content predictive-search__item-content--centered';

    const title = document.createElement('p');
    title.className = 'predictive-search__item-heading h5';
    title.textContent = product.title || '';
    content.appendChild(title);
    link.appendChild(content);
    li.appendChild(link);

    return li;
  };

  const installPatch = () => {
    const PredictiveSearchElement = customElements.get('predictive-search');
    if (!PredictiveSearchElement || PredictiveSearchElement.prototype.__isPromocionalesFallbackInstalled) return false;

    const originalRender = PredictiveSearchElement.prototype.renderSearchResults;

    PredictiveSearchElement.prototype.renderSearchResults = function(resultsMarkup) {
      originalRender.call(this, resultsMarkup);

      const rawTerm = this.getQuery ? this.getQuery() : '';
      const term = normalize(rawTerm);
      if (term.length < 2) return;

      const currentTerm = term;
      const productList = this.predictiveSearchResults?.querySelector('#predictive-search-results-products-list');
      const existingLinks = Array.from(
        this.predictiveSearchResults?.querySelectorAll('a[href*="/products/"]') || []
      );
      const existingHandles = new Set(
        existingLinks
          .map((link) => link.getAttribute('href') || '')
          .map((href) => href.split('/products/')[1]?.split('?')[0])
          .filter(Boolean)
      );

      const maxProducts = 6;
      const needed = Math.max(0, maxProducts - existingHandles.size);
      if (!needed) return;

      getCatalog().then((products) => {
        if (normalize(this.getQuery ? this.getQuery() : '') !== currentTerm) return;

        const matches = products
          .map((product) => ({ product, score: scoreProduct(product, currentTerm) }))
          .filter(({ product, score }) => score > 0 && !existingHandles.has(product.handle))
          .sort((a, b) => b.score - a.score || String(a.product.title).localeCompare(String(b.product.title), 'es'))
          .slice(0, needed)
          .map(({ product }) => product);

        if (!matches.length) return;

        let list = productList;
        if (!list) {
          const root = this.predictiveSearchResults?.querySelector('#predictive-search-results');
          const searchButton = root?.querySelector('#predictive-search-option-search-keywords');
          if (!root || !searchButton) return;

          const group = document.createElement('div');
          group.className = 'predictive-search__result-group is-local-search-fallback';

          const wrapper = document.createElement('div');
          const heading = document.createElement('h2');
          heading.className = 'predictive-search__heading text-body caption-with-letter-spacing';
          heading.textContent = 'PRODUCTOS';

          list = document.createElement('ul');
          list.className = 'predictive-search__results-list list-unstyled';
          list.setAttribute('role', 'group');
          list.setAttribute('aria-label', 'Productos');

          wrapper.appendChild(heading);
          wrapper.appendChild(list);
          group.appendChild(wrapper);
          root.insertBefore(group, searchButton);
        }

        matches.forEach((product, index) => {
          list.appendChild(createProductItem(product, index));
        });

        this.open?.();
      });
    };

    PredictiveSearchElement.prototype.__isPromocionalesFallbackInstalled = true;
    return true;
  };

  const boot = () => {
    if (installPatch()) return;
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (installPatch() || attempts >= 40) clearInterval(timer);
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();